// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info_screen {
    margin-top: 40px;
    height: 100%;
    background-color: white;
    display: grid;
    grid-template-columns: 1fr 1fr;
    border-radius: 5px;
    position: relative;
}


@media (max-width: 1000px) {
    .info_screen {
        grid-template-columns: 1fr;
    }
    .info_images {
        display: none;
    }
    .info_step > h2 {
        transform: translateY(0)!important;
    }
}

.info_content {
    padding: 20px;
}

.info_content > h1 {
    text-align: center;
    font-size: 22px;
}

.info_content_image {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 40px;
    margin-bottom: 20px;
}

.info_content_image > img {
    width: 70px;
}

.info_step > h2 {
    font-size: 16px;
}

.info_step_title {
    display: flex;
    align-items: flex-start;
}

.info_step_title > div {
    width: 9px;
    height: 9px;
    min-width: 9px;
    min-height: 9px;
    background-color: #26203E;
    border-radius: 50%;
    margin-right: 10px;
    margin-top: 15px;
}

.info_step_title > h3 {
    font-size: 16px;
    margin-top: 7px;
    margin-bottom: 7px;
    line-height: 25px;
}

.info_step_sub_title {
    display: flex;
    align-items: flex-start;
    padding-left: 20px;
    margin-bottom: 7px;
}

.info_step_sub_title > div {
    width: 9px;
    height: 9px;
    min-width: 9px;
    min-height: 9px;
    background-color: white;
    border-radius: 50%;
    margin-right: 10px;
    border: 2px solid #26203E;
    margin-top: 5px;
}

.info_step_sub_title > p {
    margin: 0;
    font-size: 14px;
    line-height: 20px;
}

.info_step > p {
    font-size: 13px;
    line-height: 20px;
    margin-bottom: 30px;
}

.info_back_btn {
    position: absolute;
    bottom: 0;
    left: 15px;
    width: 50px;
    cursor: pointer;
    color: rgba(19,15,58,0.4);
}

@media (max-width: 1000px) {
    .info_back_btn {
        bottom: -10px;
    }
}

.info_back_btn:hover {
    color: rgba(19,15,58,0.7);
}

.info_images {
    min-height: 730px;
    background-position: center;
    background-size: contain!important;
    background-repeat: no-repeat;
    background-color: #F4F4F4;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Widgets/Checklist/Components/InfoScreen/InfoScreen.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;AACtB;;;AAGA;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,aAAa;IACjB;IACA;QACI,kCAAkC;IACtC;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,WAAW;IACX,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,cAAc;IACd,eAAe;IACf,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,2BAA2B;IAC3B,kCAAkC;IAClC,4BAA4B;IAC5B,yBAAyB;AAC7B","sourcesContent":[".info_screen {\n    margin-top: 40px;\n    height: 100%;\n    background-color: white;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    border-radius: 5px;\n    position: relative;\n}\n\n\n@media (max-width: 1000px) {\n    .info_screen {\n        grid-template-columns: 1fr;\n    }\n    .info_images {\n        display: none;\n    }\n    .info_step > h2 {\n        transform: translateY(0)!important;\n    }\n}\n\n.info_content {\n    padding: 20px;\n}\n\n.info_content > h1 {\n    text-align: center;\n    font-size: 22px;\n}\n\n.info_content_image {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 40px;\n    margin-bottom: 20px;\n}\n\n.info_content_image > img {\n    width: 70px;\n}\n\n.info_step > h2 {\n    font-size: 16px;\n}\n\n.info_step_title {\n    display: flex;\n    align-items: flex-start;\n}\n\n.info_step_title > div {\n    width: 9px;\n    height: 9px;\n    min-width: 9px;\n    min-height: 9px;\n    background-color: #26203E;\n    border-radius: 50%;\n    margin-right: 10px;\n    margin-top: 15px;\n}\n\n.info_step_title > h3 {\n    font-size: 16px;\n    margin-top: 7px;\n    margin-bottom: 7px;\n    line-height: 25px;\n}\n\n.info_step_sub_title {\n    display: flex;\n    align-items: flex-start;\n    padding-left: 20px;\n    margin-bottom: 7px;\n}\n\n.info_step_sub_title > div {\n    width: 9px;\n    height: 9px;\n    min-width: 9px;\n    min-height: 9px;\n    background-color: white;\n    border-radius: 50%;\n    margin-right: 10px;\n    border: 2px solid #26203E;\n    margin-top: 5px;\n}\n\n.info_step_sub_title > p {\n    margin: 0;\n    font-size: 14px;\n    line-height: 20px;\n}\n\n.info_step > p {\n    font-size: 13px;\n    line-height: 20px;\n    margin-bottom: 30px;\n}\n\n.info_back_btn {\n    position: absolute;\n    bottom: 0;\n    left: 15px;\n    width: 50px;\n    cursor: pointer;\n    color: rgba(19,15,58,0.4);\n}\n\n@media (max-width: 1000px) {\n    .info_back_btn {\n        bottom: -10px;\n    }\n}\n\n.info_back_btn:hover {\n    color: rgba(19,15,58,0.7);\n}\n\n.info_images {\n    min-height: 730px;\n    background-position: center;\n    background-size: contain!important;\n    background-repeat: no-repeat;\n    background-color: #F4F4F4;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
